import React from 'react';
import {
  Box,
  Col,
  Flex,
  HStack,
  Image,
  Text,
  VStack,
  GridContainer,
  Row,
  useBreakpoint,
  Divider,
  Link
} from '@reverb-ui/react';
import loginBackgroundIcon from './../../assets/icons/ion-logo-background.svg';
import ionIcon from './../../assets/icons/ion-icon.svg';
import ionColorIcon from './../../assets/icons/ion-color-icon.svg';
import { ArrowCornerDownLeft } from '@reverb-ui/icons-react';

type ShellProps = {
  children: React.ReactNode;
};

export const Shell = ({ children }: ShellProps) => {
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === 'mobile-xs' || breakpoint === 'mobile-sm' || breakpoint === "base";

  return (
    <Box
      minH="100vh"
      overflow="hidden"
      bgGradient={{"tablet-md": "linear(to-tl, blue.500, purple.500)"}}
    >
      <Box
        bgImage={`url(${loginBackgroundIcon})`}
        bgRepeat="no-repeat"
        h="full"
        bgSize="calc(100vh - 120px) calc(100vh - 120px)"
        bgPosition="100% 60px"
        bgAttachment="fixed"
      >
        <Box
            overflow="auto"
            // bgImage={`url(${loginBackgroundIcon})`}
            bgRepeat="no-repeat"
            bgSize="100%"
            bgPosition="100% 0%"
            bgAttachment="fixed"
            minH="100vh"
            w="full"
            h="full"
        >
          <GridContainer w="full" h="full">
            <Row justifyContent="center">
              <Col direction="column" col={10} py="60px">
                <Flex justifyContent={{ "base": "center", "tablet-md": "start" }}>
                  <Image src={isMobile ? ionColorIcon : ionIcon} h={{ "base": "50px", "tablet-md": "77px" }}/>
                </Flex>
              </Col>
            </Row>
            <Row justifyContent="center" flex={1}>
              <Col col={{ 'desktop-xl': 4, 'desktop-lg': 5, 'desktop-2xl': 4 }[breakpoint] || 5}>
                <VStack
                    flex={1}
                    height="full"
                    width="full"
                    bgRepeat="no-repeat"
                    bgPosition="top right"
                    backgroundAttachment="fixed"
                >
                  {children}
                </VStack>
              </Col>
            </Row>
            <Row justifyContent="center" pt={{ base: 6, "tablet-md": "60px" }}>
              <Col
                  col={10}
                  alignItems={{ base: "center", "tablet-md": "start" }}
                  direction="column"
              >
                {isMobile && (
                    <Divider w="full"/>
                )}
                <Link href="https://rockcontent.com/products/ion" >
                  <HStack w="full" color="white" py={8}>
                    <Box>
                      <ArrowCornerDownLeft color={isMobile ? "blue.500" : "white"} />
                    </Box>
                    <Text
                        fontWeight="bold"
                        color={{ base: "blue.500", "tablet-md": "white" }}
                    >
                      Return to Ion's homepage
                    </Text>
                  </HStack>
                </Link>
              </Col>
            </Row>
          </GridContainer>
        </Box>
      </Box>
    </Box>
  );
};
